import { validateAndGetUrlWithOrgSlug } from "../utils/index.js";
const usePureStudentUrls = (params)=>{
    const { me, isLearnDashboardEnabledForPremium, isLearnDashboardEnabledForDegree } = params || {};
    const hasAccessToLearnDashboard = me?.isB2B || me?.isPremium && isLearnDashboardEnabledForPremium || me?.isActiveDegree && isLearnDashboardEnabledForDegree;
    let homeUrl = '/';
    if (me) homeUrl = validateAndGetUrlWithOrgSlug({
        me,
        url: hasAccessToLearnDashboard ? '/learn/' : '/',
        fallbackUrl: hasAccessToLearnDashboard ? '/learn/' : '/home/'
    });
    return {
        homeUrl,
        myCoursesUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/my-courses/enrolled/' : '/panel/mis-cursos/'
        }),
        myMicroDegreeUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/microdegree/' : '/panel/mis-cursos/microdegree/'
        }),
        myBootcampUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/bootcamp/' : '/panel/mis-cursos/bootcamp/'
        }),
        myAcademiesUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/academies/' : '/panel/mis-cursos/academias/'
        }),
        myTracksUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/my-courses/tracks/' : '/panel/mis-cursos/especializaciones/'
        }),
        mySavedCoursesUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/my-courses/saved/' : '/panel/mis-cursos-guardados/'
        }),
        myProjectsUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/projects/' : '/panel/mis-proyectos/'
        }),
        myDiplomasUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/certificates/' : '/panel/mis-diplomas/'
        }),
        myStudyPlanUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/studyplan/' : '/panel/mi-plan-de-estudios/'
        }),
        myClassNotesUrl: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/my-courses/notes/' : '/panel/mis-apuntes/'
        }),
        contentForYou: validateAndGetUrlWithOrgSlug({
            me,
            url: hasAccessToLearnDashboard ? '/learn/content-for-you/' : '/'
        })
    };
};
const hooks_usePureStudentUrls = usePureStudentUrls;
export default hooks_usePureStudentUrls;
export { usePureStudentUrls };
